module.exports = __webpack_public_path__ + "img/br13.e66f621.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br13.jpg
// module id = s+5a
// module chunks = 0